
import {
  Component,
  Vue,
} from 'vue-property-decorator';
import { StayRoomModule } from '@/store/modules/stayRoom';

@Component({
  name: 'ApplicationInfoForm',
})
export default class extends Vue {
  get clientFields() {
    return StayRoomModule.form.clientFields;
  }
}
